import { jsx as _jsx } from "react/jsx-runtime";
/**
 * 文本高亮显示器组件
 * 用于显示带有高亮部分的文本段落
 */
import { useRef, useEffect } from 'react';
/**
 * 高亮显示器组件
 * 将文本分段显示，并根据配置高亮特定段落
 */
export const Highlighter = ({ segments, highlightColor = 'rgba(52, 211, 153, 0.3)', onHighlightHover, onHighlightLeave, className = '', dataTestId = 'highlighter', }) => {
    // 添加日志控制 - 避免重复记录日志
    const hasLoggedRef = useRef(false);
    // 使用useEffect控制日志输出，只记录一次
    useEffect(() => {
        if (!hasLoggedRef.current) {
            // 调试日志: 记录高亮组件渲染
            hasLoggedRef.current = true;
        }
    }, [segments]); // 仅在segments变化时考虑重新记录
    // 处理高亮区域鼠标进入事件
    const handleMouseEnter = (e, id, data // USE NEW TYPE
    ) => {
        if (onHighlightHover && data) {
            onHighlightHover(id, data, e.currentTarget); // data is now UiHighlightTooltipData
        }
    };
    // 处理高亮区域鼠标离开事件
    const handleMouseLeave = () => {
        if (onHighlightLeave) {
            onHighlightLeave();
        }
    };
    return (_jsx("div", { className: `text-paragraph ${className}`, "data-testid": dataTestId, children: segments.map((segment, index) => segment.highlighted ? (_jsx("span", { className: "highlighted-text relative cursor-pointer px-px rounded", style: { backgroundColor: highlightColor }, "data-segment-id": segment.id, onMouseEnter: e => handleMouseEnter(e, segment.id, segment.data), onMouseLeave: handleMouseLeave, children: segment.text }, `segment-${segment.id || index}`)) : (_jsx("span", { children: segment.text }, `segment-${segment.id || index}`))) }));
};
export default Highlighter;
//# sourceMappingURL=Highlighter.js.map